import { render, staticRenderFns } from "./QAHelper.vue?vue&type=template&id=163aca8a&scoped=true&"
import script from "./QAHelper.vue?vue&type=script&lang=js&"
export * from "./QAHelper.vue?vue&type=script&lang=js&"
import style0 from "./QAHelper.vue?vue&type=style&index=0&id=163aca8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163aca8a",
  null
  
)

export default component.exports